import { ResponsiveTableRow, useOverlay } from '@fs/zion-ui'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DmcResponsiveTable } from '../../../common/DmcResponsiveTable'
import { parseHistoricalPersonJSON } from '../../../../util/HistoricalPersonUtil'
import HistoricalPersonDataDialog from './HistoricalPersonDataDialog'

export default function HistoricalSearchResultsTable({ persons, removePersonOnDelete, updatePersonOnEdit, countries }) {
  const { t } = useTranslation()
  const [currentPerson, setCurrentPerson] = useState(persons[0])
  const [currentPersonIndex, setCurrentPersonIndex] = useState(0)
  const personDataOverlay = useOverlay()

  useEffect(() => {
    setCurrentPerson(persons[currentPersonIndex])
  }, [currentPersonIndex, persons])

  const onTableRowClick = (person, index) => {
    setCurrentPerson(person)
    setCurrentPersonIndex(index)
    personDataOverlay.open()
  }
  return (
    <>
      <DmcResponsiveTable
        atSizeColumns={{
          default: {
            labels: [
              t('givenName', 'Given Name'),
              t('name.parts.surname', 'Surname'),
              t('tools.lists.headings.birthDate', 'Birth Date'),
              t('tools.lists.whyFamous', 'Why Famous'),
            ],
            columnWidths: [3, 3, 2, 4],
          },
        }}
        totalColumnCount={4}
        separator={<br />}
        stickyHeader={false}
      >
        {persons.map((person, index) => {
          const personData = parseHistoricalPersonJSON(person.personJSON)
          return (
            <ResponsiveTableRow
              key={person.id}
              column1={personData.givenName}
              column2={personData.surname}
              column3={personData.birthDate}
              column4={personData.reasonWhyFamous}
              onClick={() => onTableRowClick(person, index)}
            />
          )
        })}
      </DmcResponsiveTable>
      {currentPerson && (
        <HistoricalPersonDataDialog
          person={currentPerson}
          removePersonOnDelete={removePersonOnDelete}
          updatePersonOnEdit={updatePersonOnEdit}
          countries={countries}
          {...personDataOverlay}
        />
      )}
    </>
  )
}
